let trade_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'trades', name: 'trades.list', component: () => import('./pages/Index.vue') },
      { path: 'trades/create', name: 'trades.create', component: () => import('./pages/Create.vue') },
      { path: 'trades/:id/edit', name: 'trades.edit', component: () => import('./pages/Edit.vue') }
    ]
  }
];

export default trade_routes;
